var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 29.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.3 -17.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.3 17.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47.336,31.53a9.5,9.5,0,1,0-17.072,0,4.245,4.245,0,0,0,.229.459L38.8,47.363l8.215-15.145C47.107,32.035,47.336,31.53,47.336,31.53ZM38.8,22.673a4.75,4.75,0,1,1-4.727,4.773A4.72,4.72,0,0,1,38.8,22.673Z",
    transform: "translate(-29.3 -17.9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.f2bffa05f3cb23257b7154b50c577cd7.svg";
export { ForwardRef as ReactComponent };